export function ButtonDesign(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: String
   */
  me.buttonBackgroundColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.buttonIconType = ko.observable();
  /*
   * C# parametr type: String
   */
  me.buttonTextColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.badgeBackgroundColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.badgeTextColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.buttonBottomXOffset = ko.observable();
  /*
   * C# parametr type: String
   */
  me.buttonBottomYOffset = ko.observable();
  /*
   * C# parametr type: String
   */
  me.buttonHeight = ko.observable();
  /*
   * C# parametr type: String
   */
  me.buttonWidth = ko.observable();
  /*
   * C# parametr type: String
   */
  me.popupHeaderBackgroundColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.popupHeaderTextColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.popupBackgroundColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.popupTextColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.popupToolButtonBackgroundColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.popupToolButtonTextColor = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function ButtonModel(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: Int64
   */
  me.id = ko.observable();
  /*
   * C# parametr type: Boolean
   */
  me.isActive = ko.observable();
  /*
   * C# parametr type: ButtonDescriptor
   */
  me.descriptor = ko.observable();
  /*
   * C# parametr type: ButtonDesign
   */
  me.design = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function ChangelogModel(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: Int64
   */
  me.id = ko.observable();
  /*
   * C# parametr type: List`1
   *  - Generic parametr of type: LocalizedText (class/struct)
   */
  me.titlesObject = ko.observableArray();

  mappingOptions.titlesObject = {
    create: function (options) {
      return new LocalizedText(options.data, me, parents);
    },
  };
  /*
   * C# parametr type: List`1
   *  - Generic parametr of type: LocalizedTextWithMetadata (class/struct)
   */
  me.contentsObject = ko.observableArray();

  mappingOptions.contentsObject = {
    create: function (options) {
      return new LocalizedTextWithMetadata(options.data, me, parents);
    },
  };
  /*
   * C# parametr type: List`1
   *  - Generic parametr of type: String (class/struct)
   */
  me.availableLngs = ko.observableArray();

  /*
   * C# parametr type: Nullable`1
   */
  me.publishedAt = ko.observable();
  /*
   * C# parametr type: Nullable`1
   */
  me.publishedUntil = ko.observable();
  /*
   * C# parametr type: Boolean
   */
  me.isPublished = ko.observable();
  /*
   * C# parametr type: Int32
   */
  me.seenCount = ko.observable();
  /*
   * C# parametr type: ThemeDescriptor
   */
  me.themeConfig = ko.observable();
  /*
   * C# parametr type: ChangelogDescriptor
   */
  me.partialConfig = ko.observable();
  /*
   * C# parametr type: Nullable`1
   */
  me.channelId = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function ChangelogsChannel(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: Int64
   */
  me.id = ko.observable();
  /*
   * C# parametr type: String
   */
  me.name = ko.observable();
  /*
   * C# parametr type: RulesDescriptor
   */
  me.rules = ko.observable();
  /*
   * C# parametr type: Nullable`1
   */
  me.segmentId = ko.observable();
  /*
   * C# parametr type: ChannelTypes
   */
  me.displayType = ko.observable();
  /*
   * C# parametr type: Boolean
   */
  me.isMuted = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function ChangelogsChannelConfig(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: TriggerDescriptor
   */
  me.trigger = ko.observable();
  /*
   * C# parametr type: UrlFilterDescriptor
   */
  me.urlFilter = ko.observable();
  /*
   * C# parametr type: RulesDescriptor
   */
  me.rules = ko.observable();
  /*
   * C# parametr type: Nullable`1
   */
  me.segment = ko.observable();
  /*
   * C# parametr type: Dictionary`2
   */
  me.channelPublicTitle = ko.observable();
  /*
   * C# parametr type: Dictionary`2
   */
  me.historyTitleText = ko.observable();
  /*
   * C# parametr type: Dictionary`2
   */
  me.showHistoryButtonText = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function ChangelogsConfig(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: TriggerDescriptor
   */
  me.trigger = ko.observable();
  /*
   * C# parametr type: Boolean
   */
  me.showInButton = ko.observable();
  /*
   * C# parametr type: UrlFilterDescriptor
   */
  me.urlFilter = ko.observable();
  /*
   * C# parametr type: Dictionary`2
   */
  me.historyTitleText = ko.observable();
  /*
   * C# parametr type: Dictionary`2
   */
  me.showHistoryButtonText = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function ChecklistModel(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: Int64
   */
  me.id = ko.observable();
  /*
   * C# parametr type: Boolean
   */
  me.isActive = ko.observable();
  /*
   * C# parametr type: String
   */
  me.name = ko.observable();
  /*
   * C# parametr type: ChecklistDescriptor
   */
  me.descriptor = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function ContextHelpDesign(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: Boolean
   */
  me.hasCss = ko.observable();
  /*
   * C# parametr type: String
   */
  me.css = ko.observable();
  /*
   * C# parametr type: String
   */
  me.cardBackgroundColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.cardTextColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.cardBackdropColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.cardHighlighterColor = ko.observable();
  me.cardHighlighterSpacing = ko.observable();
  me.cardHighlighterThickness = ko.observable();
  /*
   * C# parametr type: String
   */
  me.skipButtonBackgroundColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.skipButtonTextColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.dismissButtonBackgroundColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.dismissButtonTextColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.dividersColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.mainIconBackgroundColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.mainIconColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.mainIconBeaconColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.smSize = ko.observable();
  /*
   * C# parametr type: String
   */
  me.regSize = ko.observable();
  /*
   * C# parametr type: String
   */
  me.lgSize = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function ContextHelpModel(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: Int64
   */
  me.id = ko.observable();
  /*
   * C# parametr type: List`1
   *  - Generic parametr of type: String (class/struct)
   */
  me.supportedLanguages = ko.observableArray();

  /*
   * C# parametr type: String
   */
  me.baseUrl = ko.observable();
  /*
   * C# parametr type: Nullable`1
   */
  me.segmentId = ko.observable();
  /*
   * C# parametr type: ContextHelpsGroupDescriptor
   */
  me.descriptorObject = ko.observable();
  /*
   * C# parametr type: Boolean
   */
  me.isActive = ko.observable();
  /*
   * C# parametr type: String
   */
  me.name = ko.observable();
  /*
   * C# parametr type: Int64
   */
  me.projectId = ko.observable();
  /*
   * C# parametr type: String
   */
  me.publishStatus = ko.observable();
  /*
   * C# parametr type: String
   */
  me.tag = ko.observable();
  /*
   * C# parametr type: DateTime
   */
  me.lastUpdatedAt = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function FeedbackDesign(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: Boolean
   */
  me.hasCss = ko.observable();
  /*
   * C# parametr type: String
   */
  me.css = ko.observable();
  /*
   * C# parametr type: String
   */
  me.mainButtonTextColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.mainButtonBackgroundColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.mainButtonBotomYOffset = ko.observable();
  /*
   * C# parametr type: String
   */
  me.popupsHeaderBackgroundColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.popupsHeaderTextColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.popupsBackgroundColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.popupsTextColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.popupsButtonBackgroundColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.popupsButtonTextColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.textInputsBackgroundColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.textInputsTextColor = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function FeedbackModel(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: Int64
   */
  me.id = ko.observable();
  /*
   * C# parametr type: String
   */
  me.text = ko.observable();
  /*
   * C# parametr type: List`1
   *  - Generic parametr of type: String (class/struct)
   */
  me.screenshots = ko.observableArray();

  /*
   * C# parametr type: List`1
   *  - Generic parametr of type: String (class/struct)
   */
  me.videos = ko.observableArray();

  /*
   * C# parametr type: String
   */
  me.authorName = ko.observable();
  /*
   * C# parametr type: String
   */
  me.authorEmail = ko.observable();
  /*
   * C# parametr type: DateTime
   */
  me.sentAt = ko.observable();
  /*
   * C# parametr type: Boolean
   */
  me.isSolved = ko.observable();
  /*
   * C# parametr type: String
   */
  me.environmentInfo = ko.observable();
  /*
   * C# parametr type: String
   */
  me.authorUsername = ko.observable();
  /*
   * C# parametr type: String
   */
  me.authorProps = ko.observable();

  me.isNative = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}

export function InvitationModel(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: String
   */
  me.code = ko.observable();
  /*
   * C# parametr type: String
   */
  me.internalId = ko.observable();
  /*
   * C# parametr type: String
   */
  me.targetUser = ko.observable();
  /*
   * C# parametr type: Int16
   */
  me.role = ko.observable();
  /*
   * C# parametr type: DateTime
   */
  me.expiresAt = ko.observable();
  /*
   * C# parametr type: AccessDT
   */
  me.access = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}

export function CompanyJoinRequestModel(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: Int64
   */
  me.id = ko.observable();
  /*
   * C# parametr type: Int64
   */
  me.userId = ko.observable();
  /*
   * C# parametr type: Int64
   */
  me.companyId = ko.observable();
  /*
   * C# parametr type: DateTime
   */
  me.requestedAt = ko.observable();
  /*
   * C# parametr type: Int32
   */
  me.state = ko.observable();
  /*
   * C# parametr type: String
   */
  me.companyName = ko.observable();
  /*
   * C# parametr type: String
   */
  me.targetEmail = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function LocalizedText(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: String
   */
  me.lng = ko.observable();
  /*
   * C# parametr type: String
   */
  me.content = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function LocalizedTextWithMetadata(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: String
   */
  me.lng = ko.observable();
  /*
   * C# parametr type: Object
   */
  me.content = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function MoodModel(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: Int64
   */
  me.id = ko.observable();
  /*
   * C# parametr type: Int16
   */
  me.rating = ko.observable();
  /*
   * C# parametr type: String
   */
  me.followUp = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function ProjectData(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: String
   */
  me.customCss = ko.observable();
  /*
   * C# parametr type: List`1
   *  - Generic parametr of type: ClientIntegrationSettingsModel (class/struct)
   */
  me.allowedIntegrations = ko.observableArray();

  mappingOptions.allowedIntegrations = {
    create: function (options) {
      return new ClientIntegrationSettingsModel(options.data, me, parents);
    },
  };

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function ProjectModel(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: Int64
   */
  me.id = ko.observable();
  /*
   * C# parametr type: String
   */
  me.uniqueCode = ko.observable();
  /*
   * C# parametr type: String
   */
  me.description = ko.observable();
  /*
   * C# parametr type: String
   */
  me.name = ko.observable();
  /*
   * C# parametr type: Boolean
   */
  me.isActive = ko.observable();

  /*
   * C# parametr type: Boolean
   */
  me.isDataProtected = ko.observable();
  /*
   * C# parametr type: String
   */
  me.secretShareCode = ko.observable();
  /*
   * C# parametr type: String[]
   *  - Generic parametr of type:
   */
  me.supportedLanguages = ko.observableArray();

  /*
   * C# parametr type: List`1
   *  - Generic parametr of type: String (class/struct)
   */
  me.allowedDomains = ko.observableArray();

  /*
   * C# parametr type: String
   */
  me.baseUrl = ko.observable().extend({ urlize: true });
  /*
   * C# parametr type: TourDesign
   */
  me.tourDesignObject = ko.observable();
  /*
   * C# parametr type: Boolean
   */
  me.hasCustomTourDesign = ko.observable();
  /*
   * C# parametr type: ContextHelpDesign
   */
  me.contextHelpDesignObject = ko.observable();
  /*
   * C# parametr type: Boolean
   */
  me.hasCustomContextHelpDesign = ko.observable();
  /*
   * C# parametr type: List`1
   *  - Generic parametr of type: String (class/struct)
   */
  me.allowedUsers = ko.observableArray();

  /*
   * C# parametr type: Nullable`1
   */
  me.avatarFileId = ko.observable();
  /*
   * C# parametr type: String
   */
  me.color = ko.observable();
  /*
   * C# parametr type: ApiSettings
   */
  me.apiSettings = ko.observable();
  /*
   * C# parametr type: List`1
   *  - Generic parametr of type: String (class/struct)
   */
  me.deniedDomains = ko.observableArray();

  /*
   * C# parametr type: Int64
   */
  me.companyId = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function ProjectSharing(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: Int64
   */
  me.id = ko.observable();
  /*
   * C# parametr type: Int64
   */
  me.userId = ko.observable();
  /*
   * C# parametr type: Int64
   */
  me.projectId = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function SegmentModel(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: Int64
   */
  me.id = ko.observable();
  /*
   * C# parametr type: String
   */
  me.name = ko.observable();
  /*
   * C# parametr type: RulesDescriptor
   */
  me.rules = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function TourDesign(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: Boolean
   */
  me.hasCss = ko.observable();
  /*
   * C# parametr type: String
   */
  me.css = ko.observable();
  /*
   * C# parametr type: String
   */
  me.cardBackgroundColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.cardTextColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.cardBackdropColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.cardHighlighterColor = ko.observable();
  me.cardHighlighterSpacing = ko.observable();
  me.cardHighlighterThickness = ko.observable();
  /*
   * C# parametr type: String
   */
  me.skipButtonBackgroundColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.skipButtonTextColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.nextButtonBackgroundColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.nextButtonTextColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.counterTextColor = ko.observable();
  /*
   * C# parametr type: String
   */
  me.dividersColor = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function TourModel(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: Int64
   */
  me.id = ko.observable();
  /*
   * C# parametr type: String
   */
  me.name = ko.observable();
  /*
   * C# parametr type: Nullable`1
   */
  me.segmentId = ko.observable();
  /*
   * C# parametr type: TourDescriptor
   */
  me.descriptorObject = ko.observable();
  /*
   * C# parametr type: Boolean
   */
  me.isActive = ko.observable();
  /*
   * C# parametr type: Int64
   */
  me.projectId = ko.observable();
  /*
   * C# parametr type: List`1
   *  - Generic parametr of type: String (class/struct)
   */
  me.supportedLanguages = ko.observableArray();

  /*
   * C# parametr type: String
   */
  me.baseUrl = ko.observable();
  /*
   * C# parametr type: String
   */
  me.publishStatus = ko.observable();
  /*
   * C# parametr type: Boolean
   */
  me.showInButton = ko.observable();
  /*
   * C# parametr type: Boolean
   */
  me.showAsFinishedInButton = ko.observable();
  /*
   * C# parametr type: String
   */
  me.tag = ko.observable();
  /*
   * C# parametr type: DateTime
   */
  me.lastUpdatedAt = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function UserModel(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: Int64
   */
  me.id = ko.observable();
  /*
   * C# parametr type: String
   */
  me.email = ko.observable();
  /*
   * C# parametr type: String
   */
  me.firstname = ko.observable();
  /*
   * C# parametr type: String
   */
  me.lastname = ko.observable();
  /*
   * C# parametr type: Nullable`1
   */
  me.projectRole = ko.observable();
  /*
   * C# parametr type: UserRole
   */
  me.companyRole = ko.observable();
  /*
   * C# parametr type: UserConfig
   */
  me.configObject = ko.observable();
  /*
   * C# parametr type: Boolean
   */
  me.isVerified = ko.observable();
  /*
   * C# parametr type: CompanyModel
   */
  me.currentCompany = ko.observable();
  /*
   * C# parametr type: Nullable`1
   */
  me.signUpAt = ko.observable();
  /*
   * C# parametr type: List`1
   *  - Generic parametr of type: ProjectSharing (class/struct)
   */
  me.projectSharings = ko.observableArray();

  mappingOptions.projectSharings = {
    create: function (options) {
      return new ProjectSharing(options.data, me, parents);
    },
  };

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function UserNotificationsSettingsModel(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: Boolean
   */
  me.newFeedbackImmediately = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function VisualEventsGroupModel(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: Int64
   */
  me.id = ko.observable();
  /*
   * C# parametr type: Boolean
   */
  me.isActive = ko.observable();
  /*
   * C# parametr type: String
   */
  me.name = ko.observable();
  /*
   * C# parametr type: VisualEventsGroupDescriptor
   */
  me.descriptor = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function IssueModel(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: String
   */
  me.username = ko.observable();
  /*
   * C# parametr type: String
   */
  me.cardId = ko.observable();
  /*
   * C# parametr type: String
   */
  me.reason = ko.observable();
  /*
   * C# parametr type: DateTime
   */
  me.at = ko.observable();
  /*
   * C# parametr type: String
   */
  me.selector = ko.observable();
  /*
   * C# parametr type: String
   */
  me.url = ko.observable();
  /*
   * C# parametr type: String
   */
  me.urlTemplate = ko.observable();
  /*
   * C# parametr type: String
   */
  me.cardName = ko.observable();
  /*
   * C# parametr type: Nullable`1
   */
  me.containerId = ko.observable();
  /*
   * C# parametr type: String
   */
  me.containerName = ko.observable();
  /*
   * C# parametr type: String
   */
  me.id = ko.observable();
  /*
   * C# parametr type: Nullable`1
   */
  me.isResolved = ko.observable();
  /*
   * C# parametr type: ContainerTypes
   */
  me.containerType = ko.observable();

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
export function AccessDT(initObj, parentVm, parents) {
  var me = this;

  if (!parents) parents = [];
  var parentsOld = parents;

  parents = [];
  for (var i = 0; i < parentsOld.length; i++) {
    parents.push(parentsOld[i]);
  }

  parents.unshift(parentVm);

  var mappingOptions = {};

  /*
   * C# parametr type: Boolean
   */
  me.hasAccessToAllProjects = ko.observable();
  /*
   * C# parametr type: List`1
   *  - Generic parametr of type: Int64 (class/struct)
   */
  me.projectIds = ko.observableArray();

  mappingOptions.projectIds = {
    create: function (options) {
      return new Int64(options.data, me, parents);
    },
  };

  if (me._ModelExtender) {
    me._ModelExtender(me, parentVm, parents, mappingOptions);
  }

  if (initObj) {
    ko.mapping.fromJS(initObj, mappingOptions, me);
  }

  me.toJS = function () {
    var toClean = [];
    if (me.cleanBeforeSerialize) {
      toClean = me.cleanBeforeSerialize();
    }

    var toCleanMap = {};
    for (var i in toClean) {
      var key = toClean[i];
      toCleanMap[key] = me[key];
      me[key] = null;
    }

    var result = ko.toJS(me);

    for (var i in toCleanMap) {
      me[i] = toCleanMap[i];
    }

    return result;
  };
}
